import { Box, Button, useMediaQuery, useTheme } from '@mui/material'
import React, { useState } from 'react'
import { ROUTER } from '../router/constants'
import { Link, useNavigate } from 'react-router-dom'


const Buttons = ({ backLink, checkLink, backTitle, checkTitle, onCheck, isDisabled }) => {

    const theme = useTheme()
    const isLargeScreen = useMediaQuery(theme.breakpoints.up('lg'))

    return (
        <Box sx={{
            width: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: 2
        }}>
            <Box sx={{ width: '50%' }}>
                <Button
                    disabled={isDisabled}
                    component={Link}
                    to={checkLink}
                    fullWidth
                    variant="contained"
                    onClick={onCheck}
                    sx={{
                        height: '48px',
                        py: 1.5,
                        px: 3,
                        borderRadius: 1,
                        fontSize: isLargeScreen ? '16px' : '14px',
                        fontWeight: 700,
                        '&:hover': {
                            transform: 'scale(1.05)',
                            boxShadow: 6
                        },
                        transition: 'all 0.3s'
                    }}
                >
                    {checkTitle}
                </Button>
            </Box>
            <Box sx={{ width: '50%' }}>
                <Button
                    component={Link}
                    to={backLink}
                    fullWidth
                    variant="outlined"
                    sx={{
                        height: '48px',
                        py: 1.5,
                        px: 3,
                        borderRadius: 1,
                        fontSize: isLargeScreen ? '16px' : '14px',
                        fontWeight: 700,
                        color: 'primary.main',
                        borderColor: 'primary.main',
                        '&:hover': {
                            transform: 'scale(1.05)',
                            boxShadow: 6,
                            borderColor: 'primary.main'
                        },
                        transition: 'all 0.3s'
                    }}
                >
                    {backTitle}
                </Button>
            </Box>
        </Box>
    )
}

export default Buttons
